import { useProjectChatChannelAccess } from '@diagram/hooks/use-chat-channel-access';

import { Project } from 'models';
import { ChatHelpers } from 'helpers/ChatHelpers';

/**
 * The companies that collaborate on a project. A company does so through the chat channels it was
 * brought into, so the list follows the access of those channels.
 */
const useProjectCompanies = (projectId?: Project['id'] | null) => {
    const { companies: channelCompanies } = useProjectChatChannelAccess(projectId);

    return {
        companyIds: [...new Set(channelCompanies.map((row) => row.company))],
        // Includes the subcontractors, to tell whether someone's own company is part of the project
        memberCompanyIds: ChatHelpers.memberCompanyIds(channelCompanies),
    };
};

export { useProjectCompanies };
